import { useTranslation } from 'react-i18next'
import { Checkbox, IconButton } from '@mui/material'

import { Customer } from '../../types'
import BankIcon from '../../assets/icons/bank-icon.svg'
import TrashIcon from '../../assets/icons/trash-icon.svg'
import AccountIcon from '../../assets/icons/account-icon.svg'
import ArrowRightIcon from '../../assets/icons/arrow-right-icon.svg'

const CustomerDataListItem = ({
  customerData,
  processingDocument,
  disableActionOfButtons,
  handleGoToUpdateCustomerData,
  handleToggleCustomerSelection,
  handleOpenDeleteCustomerDataModal
}: {
  processingDocument: boolean
  disableActionOfButtons: boolean
  customerData: Partial<Customer>
  handleGoToUpdateCustomerData: (selectedCustomerData: Partial<Customer>) => void
  handleOpenDeleteCustomerDataModal: (selectedCustomerData: Partial<Customer>) => void
  handleToggleCustomerSelection: (selectedCustomerData: Partial<Customer>, selected: boolean) => void
}) => {
  const selectedCountry = globalThis.sessionStorage.getItem('selectedCountry') || 'COL'
  const { t } = useTranslation(['customers-management'])

  return (
    <div
      onClick={() => handleGoToUpdateCustomerData(customerData)}
      className="users-management-user-data-container"
    >
      <div className="users-management-user-data-profile">
        {processingDocument === false && (
          <Checkbox
            checked={customerData.selected ?? false}
            disabled={disableActionOfButtons}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => {
              handleToggleCustomerSelection(customerData, event.target.checked)
            }}
          />
        )}
        <div className="users-management-user-image-profile">
          <img
            src={AccountIcon}
            alt="account-icon"
          />
        </div>
        <div className="users-management-user-name-profile">{customerData?.registeredFullName?.toUpperCase()}</div>
      </div>
      <div className="users-management-user-data-status users-management-user-data-bank-data-container">
        <div>
          <img
            src={BankIcon}
            alt="bank-icon"
          />
        </div>
        {(selectedCountry === 'COL' || selectedCountry === 'ARG' || selectedCountry === 'CHI' || selectedCountry === 'PER' || selectedCountry === 'BRA') && (
          <div className="users-management-bank-text">
            {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
              <>{`${customerData?.bankAccountsData[0].bankName || ''} - No. ${customerData?.bankAccountsData[0].bankNumber}`}</>
            ) : (
              <>{t('notRegistered')}</>
            )}
          </div>
        )}
        {selectedCountry === 'MEX' && (
          <div className="users-management-bank-text">
            {Array.isArray(customerData.bankAccountsData) && customerData.bankAccountsData.length > 0 ? (
              <>{`${customerData?.bankAccountsData[0].bankAccountType.toUpperCase()} - No. ${customerData?.bankAccountsData[0].bankNumber}`}</>
            ) : (
              <>{t('notRegistered')}</>
            )}
          </div>
        )}
      </div>
      <div
        className="users-management-user-data-actions"
        style={processingDocument === false ? { justifyContent: 'space-between' } : { justifyContent: 'flex-end' }}
      >
        {processingDocument === false && (
          <IconButton
            edge="end"
            sx={{ color: '#107569' }}
            disabled={disableActionOfButtons}
            onClick={(event) => {
              event.stopPropagation()
              handleOpenDeleteCustomerDataModal(customerData)
            }}
            aria-label="toggle password visibility"
          >
            <img
              src={TrashIcon}
              alt="trash-icon"
            />
          </IconButton>
        )}
        <div className="users-management-user-data-arrow-right">
          <img
            src={ArrowRightIcon}
            alt="arrow-right-icon"
          />
        </div>
      </div>
    </div>
  )
}

export default CustomerDataListItem
